import { createSlice } from "@reduxjs/toolkit";
import { getData } from "../../services";

const initialState = {
  accessData: null,
  businessAccess: null, // { change_management, cost_and_billing, timesheet_management }
};

export const accessSlice = createSlice({
  name: "accessDetails",
  initialState,
  reducers: {
    setAccessData: (state, action) => {
      state.accessData = action.payload;
    },
    setBusinessAccess: (state, action) => {
      state.businessAccess = action.payload;
    },
  },
});

export const { setAccessData, setBusinessAccess } = accessSlice.actions;

// Corrected selector
export const stateSelector = (state) => state?.accessDetails?.accessData;

export const fetchAccessData = (euid) => async (dispatch) => {
  try {
    const res = await getData({
      endpoint: "Employee/GetEmployeeAccess",
      params: { employee_id: euid },
    });
    if (res) {
      dispatch(setAccessData(res?.data));
      dispatch(setBusinessAccess(res?.data?.access_to_business ?? null));
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

export default accessSlice.reducer;
